import React, { Component } from 'react';
import { Modal } from 'reactstrap';
import Select from "react-select";

class FormCreateShow extends Component {

    handleSubmit = e => {
        e.preventDefault();
    };

    render() {
        return (
            <Modal
                isOpen={this.props.modal}
                toggle={this.props.toggle}
                className="modal-dialog-centered rk-modal"
                backdrop={this.props.backdrop}
            >
                <div className="rk-modal__header">
                    <span className="rk-modal__header-icon"><i className="fas fa-star"></i></span>
                    <h5>{this.props.title}</h5>
                    <button type="button" className="rk-modal__close" onClick={() => this.props.toggle()}>
                        <i className="fas fa-times"></i>
                    </button>
                </div>

                <form onSubmit={this.handleSubmit}>
                    <div className="rk-modal__body">
                        <div className="row">

                            <div className="col-md-12">
                                <div className="rk-field">
                                    <label className="rk-label">Fecha <small className="validate-label">(opcional)</small></label>
                                    <input
                                        type="date"
                                        name="date_score"
                                        value={this.props.formValues.date_score}
                                        onChange={this.props.onChangeForm}
                                        className="rk-input"
                                    />
                                </div>
                            </div>

                            <div className="col-md-12">
                                <div className="rk-field">
                                    <input
                                        type="hidden"
                                        name="responsible_user_id"
                                        value={this.props.formAutocomplete.responsible_user_id}
                                    />
                                    <label className="rk-label">Responsable <small className="validate-label">(opcional)</small></label>
                                    <Select
                                        onChange={this.props.onChangeAutocomplete}
                                        options={this.props.users}
                                        autoFocus={false}
                                        className="link-form"
                                        value={this.props.formAutocomplete}
                                    />
                                </div>
                            </div>

                            {this.props.showAddUsers && (
                                <div className="col-md-12">
                                    <div className="rk-field">
                                        <input
                                            type="hidden"
                                            name="user_ids"
                                            value={this.props.procesoIds}
                                        />
                                        <label className="rk-label">Gestores</label>
                                        <Select
                                            onChange={this.props.handleChangeAutocompleteUsers}
                                            isMulti
                                            defaultValue={this.props.editValues}
                                            closeMenuOnSelect={false}
                                            name="user_ids"
                                            options={this.props.users}
                                            className="basic-multi-select"
                                            classNamePrefix="select"
                                            placeholder="Seleccione"
                                        />
                                    </div>
                                </div>
                            )}

                            {this.props.errorValues == false && (
                                <div className="col-md-12">
                                    <div className="rk-alert">
                                        <i className="fas fa-exclamation-circle"></i>
                                        Debes de completar todos los campos requeridos
                                    </div>
                                </div>
                            )}

                            {this.props.isLoaded && (
                                <div className="col-md-12">
                                    <div className="rk-alert" style={{ background: "#f0fdf4", borderColor: "#bbf7d0", color: "#15803d" }}>
                                        <i className="fas fa-check-circle"></i>
                                        ¡Estamos generando tu evaluación!
                                    </div>
                                </div>
                            )}

                        </div>
                    </div>

                    <div className="rk-modal__footer">
                        <button type="button" className="rk-btn rk-btn--ghost" onClick={() => this.props.toggle()}>
                            Cerrar
                        </button>
                        <button
                            type="button"
                            className="rk-btn rk-btn--primary"
                            onClick={this.props.submitForm}
                            disabled={this.props.isLoaded}
                        >
                            <i className="fas fa-check"></i> {this.props.nameSubmit}
                        </button>
                    </div>
                </form>
            </Modal>
        );
    }
}

export default FormCreateShow;
